import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import _isNull from "lodash/isNull";
import _isFunction from "lodash/isFunction";
import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/es.promise.js";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { Paper, Row, Col, Button, FileInput, showError } from 'components/UI';
import { showApiError } from 'utils';
import { signPaymentDocument, signDocumentForPayment } from 'services';
import { pdfWrap } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
var uploadSection = {
  marginBottom: '1.5em'
};

var uploadHeader = function uploadHeader(theme) {
  return {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5em',
    fontSize: '1.25rem',
    fontWeight: 600,
    color: theme.gray700,
    marginBottom: '1em',
    '& i': {
      fontSize: '1.4rem',
      color: theme.primary
    }
  };
};

var uploadDropZone = function uploadDropZone(theme) {
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '2em',
    border: "2px dashed ".concat(theme.gray200),
    borderRadius: 8,
    backgroundColor: theme.gray50 || '#fafafa',
    transition: 'border-color 0.2s, background-color 0.2s',
    '&:hover': {
      borderColor: theme.primary,
      backgroundColor: theme.primaryLight || '#f0f7ff'
    }
  };
};

var uploadIcon = function uploadIcon(theme) {
  return {
    fontSize: '3rem',
    color: theme.gray300,
    marginBottom: '0.6em',
    lineHeight: 1
  };
};

var uploadMainText = function uploadMainText(theme) {
  return {
    fontSize: '1.15rem',
    color: theme.gray600,
    marginBottom: '1em',
    textAlign: 'center'
  };
};

var uploadSubText = function uploadSubText(theme) {
  return {
    fontSize: '1rem',
    color: theme.gray400,
    marginTop: '0.8em',
    fontWeight: 500
  };
};

var uploadFileInfo = function uploadFileInfo(theme) {
  return {
    fontSize: '0.95rem',
    color: theme.gray300,
    marginTop: '0.2em'
  };
};

var SignPayment = function SignPayment(_ref) {
  var document = _ref.document,
      creditId = _ref.creditId,
      onSignSuccess = _ref.onSignSuccess,
      onBack = _ref.onBack;
  var history = useHistory();
  var borrowerSignRef = useRef();
  var employeeSignRef = useRef();
  var signManualRef = useRef();
  var isSign = document === null || document === void 0 ? void 0 : document.isSign;

  var handleSubmit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _signManualRef$curren, _borrowerSignRef$curr, _employeeSignRef$curr, _borrowerSignRef$curr2, _borrowerSignRef$curr3, _employeeSignRef$curr2, _employeeSignRef$curr3;

      var fileData, borrowerBase64, employeeBase64, formData, method, params, _yield$method, _yield$method2, res, err, url;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fileData = (_signManualRef$curren = signManualRef.current) === null || _signManualRef$curren === void 0 ? void 0 : _signManualRef$curren.value;

              if (!((_borrowerSignRef$curr = borrowerSignRef.current) !== null && _borrowerSignRef$curr !== void 0 && _borrowerSignRef$curr.isEmpty() || (_employeeSignRef$curr = employeeSignRef.current) !== null && _employeeSignRef$curr !== void 0 && _employeeSignRef$curr.isEmpty() || _isNull(fileData))) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", showError('Моля, подпишете платежното!'));

            case 3:
              borrowerBase64 = (_borrowerSignRef$curr2 = borrowerSignRef.current) === null || _borrowerSignRef$curr2 === void 0 ? void 0 : (_borrowerSignRef$curr3 = _borrowerSignRef$curr2.getTrimmedCanvas()) === null || _borrowerSignRef$curr3 === void 0 ? void 0 : _borrowerSignRef$curr3.toDataURL();
              employeeBase64 = (_employeeSignRef$curr2 = employeeSignRef.current) === null || _employeeSignRef$curr2 === void 0 ? void 0 : (_employeeSignRef$curr3 = _employeeSignRef$curr2.getTrimmedCanvas()) === null || _employeeSignRef$curr3 === void 0 ? void 0 : _employeeSignRef$curr3.toDataURL();

              if (fileData) {
                formData = new FormData();
                formData.append('file', fileData);
              }

              method = document !== null && document !== void 0 && document.paymentId ? signDocumentForPayment : signPaymentDocument;
              params = document !== null && document !== void 0 && document.paymentId ? [document === null || document === void 0 ? void 0 : document.paymentId, document === null || document === void 0 ? void 0 : document.documentId] : [creditId];
              _context.next = 10;
              return method.apply(void 0, params.concat([fileData ? formData : _objectSpread(_objectSpread({}, borrowerBase64 && {
                sign_image: borrowerBase64
              }), employeeBase64 && {
                employee_sign_image: employeeBase64
              })]));

            case 10:
              _yield$method = _context.sent;
              _yield$method2 = _slicedToArray(_yield$method, 2);
              res = _yield$method2[0];
              err = _yield$method2[1];

              if (!err) {
                _context.next = 16;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 16:
              url = URL.createObjectURL(new File([res], 'filename.json', {
                type: 'application/pdf'
              }));
              _isFunction(onSignSuccess) && onSignSuccess({
                url: url,
                isSign: true
              });

            case 18:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleSubmit() {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(Paper, {
    header: "\u041F\u043E\u0434\u043F\u0438\u0441 \u043D\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u043D\u043E"
  }, ___EmotionJSX("div", {
    css: pdfWrap
  }, ___EmotionJSX("iframe", {
    title: "\u041F\u043B\u0430\u0442\u0435\u0436\u043D\u043E",
    src: document === null || document === void 0 ? void 0 : document.url,
    width: "100%",
    height: "700px"
  })), !isSign && ___EmotionJSX("div", {
    css: uploadSection
  }, ___EmotionJSX("h5", {
    css: uploadHeader
  }, ___EmotionJSX("i", {
    className: "las la-cloud-upload-alt"
  }), "\u041F\u0440\u0438\u043A\u0430\u0447\u0432\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442"), ___EmotionJSX("div", {
    css: uploadDropZone
  }, ___EmotionJSX("div", {
    css: uploadIcon
  }, ___EmotionJSX("i", {
    className: "las la-file-upload"
  })), ___EmotionJSX("p", {
    css: uploadMainText
  }, "\u0418\u0437\u0431\u0435\u0440\u0435\u0442\u0435 \u0441\u043A\u0430\u043D\u0438\u0440\u0430\u043D \u0438\u043B\u0438 \u0441\u043D\u0438\u043C\u0430\u043D \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442"), ___EmotionJSX(FileInput, {
    ref: signManualRef,
    fileFormat: true,
    accept: "image/*, application/pdf",
    formId: "file",
    label: "\u0418\u0437\u0431\u0435\u0440\u0438 \u0444\u0430\u0439\u043B",
    id: "file",
    required: true,
    max: 30
  }), ___EmotionJSX("p", {
    css: uploadSubText
  }, "JPG, PNG \u0438\u043B\u0438 PDF"), ___EmotionJSX("p", {
    css: uploadFileInfo
  }, "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u0435\u043D \u0440\u0430\u0437\u043C\u0435\u0440: 30 MB"))), ___EmotionJSX(Row, {
    horizontalGap: 16,
    verticalGap: 8
  }, _isFunction(onBack) && ___EmotionJSX(Col, {
    md: "auto"
  }, ___EmotionJSX(Button, {
    type: "info",
    onClick: onBack,
    margin: "0 1em 0 0"
  }, "\u041D\u0430\u0437\u0430\u0434")), ___EmotionJSX(Col, {
    displayFlex: true,
    md: true,
    justify: "flex-end"
  }, ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Button, {
    type: "secondary",
    onClick: function onClick() {
      return history.push('/credits');
    },
    margin: "0 1em 0 0"
  }, "\u0417\u0430\u0442\u0432\u043E\u0440\u0438"), !isSign && ___EmotionJSX(Button, {
    onClick: handleSubmit
  }, "\u041F\u0440\u0438\u043A\u0430\u0447\u0438")))));
};

SignPayment.propTypes = {
  creditId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  document: PropTypes.any,
  onSignSuccess: PropTypes.func,
  onBack: PropTypes.func
};
export default SignPayment;